import { registerRenderer, registerValidator } from "./form/useForm"
import { renderTextArea } from "./form/rendering"
import ColorButton from "./ui/ColorButton"
import React from "react"

export function registerRenderers(currentPalette) {

    registerRenderer(
        "Radiating",
        "center",
        (ctx, fd, value) => {

            const palette = currentPalette()

            return (
                <label>
                    {
                        palette.map((c, index) => (
                            <ColorButton
                                key={ index }
                                color={ palette[index] }
                                index={ index }
                                active={ +value }
                                setActive={ n => ctx.setValue(fd, String(n)) }
                                toggle={ false }
                            />
                        ))
                    }
                    center
                </label>
            )
        }
    )
}
